import React, { FC, Fragment, useContext, useEffect, useState } from 'react';

import { Button, CourseWrapper, FlexRowSpaceEvenly } from '../../common-styles/common-styles';
import { Course, Match, TeamGameMatch, TeamGameMatchTeam } from '../../../../database.schema';

import { ScoreCard } from './score-card';
import { UpdateButton } from './update-button';
import { isLoggedIn } from '../../../app/authentication/auth';
import { SelectedIndexContext } from '../../../App';
import { useNavigate } from 'react-router-dom';
import { TeamGameUpdateButton } from './team-game-update-button';
import { TeamGameMatchPlayUpdateButton } from './team-game-match-play-update-button';
import { calculateOveralMatchResult, getTeamPoints } from '../../../utils/score-calculator';
import { match } from 'assert';

export type Hole = {
  hole: number;
  par: number;
  strokeIndex: number;
  score: number;
  points: number;
};
type ScoreCardProps = {
  startingHole: number;
  recordedMatch: Match;
  teamGameMatch: TeamGameMatch;
  course: Course;
  showScoreEntry: (value: boolean) => void;
  matchIndex: number;
  teamIndex: number;
  format: 'Pairs' | 'Singles';
};

export const TeamGameMatchPlayScoreCard: FC<ScoreCardProps> = ({ startingHole, teamGameMatch, recordedMatch, course, teamIndex, matchIndex, format }): JSX.Element => {
  const navigate = useNavigate();
  const [updateStatus, setUpdateStatus] = useState({ success: false, error: false });
  const { selectedTournamentIndex } = useContext(SelectedIndexContext);
  const [teamGameMatchStore, setTeamGameMatchStore] = useState<TeamGameMatch>(teamGameMatch);

  useEffect(() => {
    if (teamGameMatch.matchPlayMatches) {
      const cloneGameMatches = [...teamGameMatch.matchPlayMatches];
      const updatedTeamGame = { ...teamGameMatch.matchPlayMatches[teamIndex] };
      updatedTeamGame.resultMargin = calculateOveralMatchResult(recordedMatch.resultByHole).substring(3);
      updatedTeamGame.resultByHole = recordedMatch.resultByHole;
      updatedTeamGame.team1.points = getTeamPoints('team1', recordedMatch.resultByHole) as 0 | 0.5 | 1;
      updatedTeamGame.team2.points = getTeamPoints('team2', recordedMatch.resultByHole) as 0 | 0.5 | 1;
      cloneGameMatches.splice(teamIndex, 1, { ...updatedTeamGame });

      const cloneGameTeams = [...teamGameMatch.teams];
      cloneGameTeams[0].points = cloneGameMatches.reduce((acc, currentTeam) => acc + currentTeam.team1.points, 0);
      cloneGameTeams[1].points = cloneGameMatches.reduce((acc, currentTeam) => acc + currentTeam.team2.points, 0);
      setTeamGameMatchStore({ ...teamGameMatch, teams: [...cloneGameTeams], matchPlayMatches: [...cloneGameMatches] });
    }
  }, [teamGameMatch]);

  return (
    <Fragment>
      <h2>ScoreCard</h2>
      <CourseWrapper>Course: {course.name}</CourseWrapper>
      {updateStatus.error && <div>Update failed!!!!</div>}
      <ScoreCard startingHole={startingHole} recordedMatch={recordedMatch} course={course} format={format} />
      <FlexRowSpaceEvenly>
        {isLoggedIn() && (
          <TeamGameMatchPlayUpdateButton
            matchIndex={matchIndex}
            teamGameMatch={teamGameMatchStore}
            selectedTournamentIndex={selectedTournamentIndex}
            teamIndex={matchIndex}
            recordedMatchTeams={[...teamGameMatch.teams]}
            setUpdateStatus={setUpdateStatus}
          />
        )}
        <Button onClick={() => navigate(`/team-game-edit-results/${selectedTournamentIndex}/${matchIndex}`)}>Back</Button>
      </FlexRowSpaceEvenly>
    </Fragment>
  );
};
